import React from 'react'
import { withRouter } from 'react-router-dom'
import { NavLink } from 'react-router-dom'
import { fade, makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import InputBase from '@material-ui/core/InputBase'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import MenuIcon from '@material-ui/icons/Menu'
import SearchIcon from '@material-ui/icons/Search'
import ClearIcon from '@material-ui/icons/HighlightOff'

import Config from '../config'
import { getTenantLogoDataUrl } from '../public-config'

const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 400,
    },
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  link : {
    textDecoration :  "none",
    display : "block",
  },
  logoHolder : {
    position : 'relative',
    width : '100px',
    cursor : 'pointer',
  },
  logo : {
    position : 'absolute',
    top : '-30px',
    width : 80,
    '-webkit-filter': 'drop-shadow(3px 5px 2px rgba(0,0,0,0.3))'
  },
}))

export default withRouter(function MainNav(props) {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [logoSrc, setLogoSrc] = React.useState(null)
  const showLogo = props.showLogo !== false

  const isMenuOpen = Boolean(anchorEl)
  
  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleMenuOpen = event => {
    setAnchorEl(event.currentTarget);
  }

  const goToDashboard = () => {
    props.history.push('/')
  }

  const menuId = 'primary-search-account-menu'

  const userData = Config.getConfig("userData")
  const appTitle = Config.getConfig("apptitle")

  React.useEffect(() => {
    if (!showLogo)
    {
      return
    }

    getTenantLogoDataUrl()
      .then(setLogoSrc)
      .catch(err => console.log("Error loading logo",err))
  },[showLogo])

  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {props.routes.filter(r => r.menu).filter(r => {return r.ownerOnly ? userData.systemOwner : true}).map(route => {
          return (<MenuItem key={route.url} component={NavLink} to={route.link ? route.link : route.url}>{route.name}</MenuItem>)
        }
      )}
    </Menu>
  )

  const search = event => {
    let searchTerm = event.target.value
    
    if(event.keyCode === 13)
    {
      props.searchTermChanged(searchTerm)
    }
  }

  const clearSearch = () => {
    document.getElementById("searchInput").value = ""
    props.searchTermChanged("")
  }

  return (

    <div className={classes.grow}>
      <AppBar position="static" color={props.sleeping ? "secondary" : "inherit"}>
        <Toolbar>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="open drawer"
            onClick={handleMenuOpen}
          >
            <MenuIcon />
          </IconButton>

          {showLogo &&
            <div className={classes.logoHolder} onClick={e => goToDashboard(props)}>
              {logoSrc &&
                <img
                  src={logoSrc}
                  alt={`${appTitle} logo`}
                  className={classes.logo}
                  onError={() => setLogoSrc(null)}
                />
              }
            </div>
          }

          <Typography className={classes.title} variant="h6" noWrap>
            {appTitle} · {props.activeRoute.name}
          </Typography>
          
          <div className={classes.grow} />

          {props.salesStats &&
            <Typography className={classes.title} variant="h6" noWrap>
              {props.salesStats.sales.today} : {props.salesStats.refunds.today} : £{props.salesStats.income.today.toFixed(2)}
            </Typography>
          }

          <div className={classes.grow} />

          {props.activeRoute.search &&
            <div className={classes.search}>
              <div className={classes.searchIcon}>
                <SearchIcon />
              </div>
              <InputBase
                id="searchInput"
                placeholder="Search..."
                classes={{
                  root: classes.inputRoot,
                  input: classes.inputInput,
                }}
                onKeyUp={search}
                inputProps={{ 'aria-label': 'search' }}
              />
              <IconButton onClick={event => clearSearch()} color="secondary">
                <ClearIcon/>
              </IconButton>
            </div>
          }

        </Toolbar>
      </AppBar>
      
      {renderMenu}
    </div>
  )
})
